var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.ShowBox)?_c('div',{staticStyle:{"width":"100vw","height":"100vh","background":"rgba(0, 0, 0, 0.8)","position":"fixed","z-index":"99999"}},[_c('img',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":require("./assets/images/bg_01.png")}})]):_vm._e(),_c('div',{attrs:{"id":"app"}},[_c('global-header'),_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }